export enum NoteRelatedItemType {
    Organization,
    Well,
    Workflow,
    Contact
}
